import { Box, Stack } from '@mui/material';
import { getCurrentBoardId, getFeatureListForTasksHeaderSelector } from '@common-reducers/BoardsSelectors';
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook';
import { useEffect, useRef } from 'react';
import { useElementSize } from 'usehooks-ts';
import AddViewDropdownShadcn from './add-view-dropdown-shadcn';
import MenuTriggerTooltip from '@common/components/menu-trigger-tooltip/menu-trigger-tooltip';
import TabsMoreButton from './tabs-more-button';
import TaskHeaderTab from './task-header-tab';
import { taskActions } from '@common-reducers/TasksReducer';
import { namespace } from '@common/config/constants';
import { useTranslation } from 'react-i18next';

export default function BoardTabList() {
    const { t } = useTranslation(namespace);
    // const tabParentRef = useRef<HTMLDivElement>(null)
    const [tabParentRef, { width: rawWidth }] = useElementSize()
    const width = rawWidth ?? 0
    const tabsRef = useRef<Array<HTMLDivElement | null>>([]);
    const dispatch = useAppDispatch()
    const currentBoardId = useAppSelector(getCurrentBoardId)
    const fakeFeatureListForMeasuringTheWidthOfEachTab = useAppSelector((state) => getFeatureListForTasksHeaderSelector(state, -1, width, tabsRef));
    useEffect(() => {
        tabsRef.current = tabsRef.current.slice(0, fakeFeatureListForMeasuringTheWidthOfEachTab?.length);

    }, [fakeFeatureListForMeasuringTheWidthOfEachTab]);

    useEffect(() => {
        dispatch(taskActions.setCurrentBoardView({
            type: 'board',
            id: currentBoardId
        }))
    },[])

    const featureList = useAppSelector((state) => getFeatureListForTasksHeaderSelector(state, 0, width, tabsRef));
    return (

        <Stack direction='column'>
            <Stack id='board-tab-list' direction='row'  alignItems="center" sx={{ px: { xs: '12px', sm: '40px' }, height: '69px', overflowX: 'auto' }} ref={tabParentRef}>

                {featureList.map((feature, index) => (
                    <Box
                        key={`real_tab_button_${index}`}>
                        <TaskHeaderTab
                            featureId={feature?._id ? feature._id.toString() : ''}
                            featureName={feature?.name ?? ''}
                            type={feature?.type}
                            index={index} />
                    </Box>
                ))}
                {featureList?.length !== fakeFeatureListForMeasuringTheWidthOfEachTab?.length &&
                    <TabsMoreButton
                        width={width}
                        tabsRef={tabsRef}
                    />
                }
                {/* Shut while its menu is open (hovering the portaled menu bubbles back here
                    through React) — see useMenuTriggerTooltip. */}
                <MenuTriggerTooltip title={t('boardTabList.addView')} placement="right" sx={{ marginLeft: '4px' }}>
                    {(onMenuOpenChange) => <AddViewDropdownShadcn onOpenChange={onMenuOpenChange} />}
                </MenuTriggerTooltip>

            </Stack>
            <Stack direction='row'>
                {
                    fakeFeatureListForMeasuringTheWidthOfEachTab.map((feature, index) => (
                        <Box
                            ref={(el: HTMLDivElement | null) => { tabsRef.current[index] = el; }}
                            key={`fake_tab_button_${index}`}
                            style={{
                                visibility: 'hidden',
                                pointerEvents: 'none',
                                height: 0,
                            }}>
                            <TaskHeaderTab
                                featureId={feature?._id ? feature._id.toString() : ''}
                                featureName={feature?.name ?? ''}
                                type={feature?.type}
                                index={index} />
                        </Box>
                    ))
                }
            </Stack>
        </Stack>
    )
}
